import {FilterFactory, OperatorFilter, TermFilter} from '@dofleini/query-builder';
import {activityPlaces} from '@mep/pae-commons';
import {useMemo} from 'react';
import {useQuery} from 'react-query';

import {CACHE_KEY_LIST_ACTIVITY_PLACE} from '@/modules/activityPlace/contants/activityPlace';
import ActivityPlaceApiService from '@/modules/activityPlace/services/ActivityPlaceApiService';

const {ACTIVITY_PLACE_STATUS} = activityPlaces;

export const useActivityPlaces = (proposalId, procedureId, filters = null, isCompanyView, isProcedureView) => {
  const _filters = useMemo(() => {
    if (filters) return filters;
    
    let result = new TermFilter({field: 'proposal', value: proposalId, objectId: true});
    
    if (isCompanyView)
      result = FilterFactory.add(result, new TermFilter({field: 'status', value: ACTIVITY_PLACE_STATUS.ACCEPTED}));
    
    if (isProcedureView)
      result = FilterFactory.add(result, new OperatorFilter({
        type: 'OR',
        filters: [
          new TermFilter({field: 'status', value: ACTIVITY_PLACE_STATUS.ACCEPTED}),
          new TermFilter({field: 'procedure', value: procedureId, objectId: true})
        ]
      }));
    return result;
  }, [filters, isCompanyView, isProcedureView, procedureId, proposalId]);
  
  return useQuery([CACHE_KEY_LIST_ACTIVITY_PLACE, proposalId, _filters], () => ActivityPlaceApiService.search({
    filters: _filters?.toQuery(),
    sort: {createdAt: 1}
  }), {
    refetchOnWindowFocus: true,
    enabled: !!proposalId
  });
};
